































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { TweenMax, Power4 } from "gsap";

@Component
export default class Contact extends Vue {
  dataText = {
    "1": {
      img:
        "https://res.cloudinary.com/nancloud/image/upload/v1606220009/LSD/WORKS/01_rkawhd.jpg",
      title: "LVNN<br>PROJECT.",
      subtitle: "Live Animation Performance",
      text:
        "LVNN (Elveneno) is an animation Project oriented towards live performance involving space, installations and the use of different technologies like real time generated graphics and GL shaders. The project has been in development phase for about 2 years now, and has been praised and awarded in experimental media encounters like Festival Internacional de la Imagen, where it received honorable mention award.",
      btn1: "LVNN Demo 1",
      link1: "https://www.youtube.com/watch?v=w30-4QhhMFM",
      btn2: "LVNN Demo 2",
      link2: "https://www.youtube.com/watch?v=-ShSQGF6fb0",
      btn3: "",
      link3: "",
    },
    "2": {
      img:
        "https://res.cloudinary.com/nancloud/image/upload/v1606220008/LSD/WORKS/02_zjzhva.jpg",
      title: "LIVE<br>DOJO.",
      subtitle: "Live Audiovisual Performance",
      text:
        "One of the main focuses of our collective is to regain attention of the present moment, to make a compliment about being right here right now. That's the reason why we lean towards live performances like VJ mixing, Mapping projection, and audiovisual performances of different kinds, specially the ones that allow us to create tension and release from operating light and sound at a given moment.",
      btn1: "BIFF Mapping",
      link1: "https://www.youtube.com/watch?v=AsmjmbvhZBA",
      btn2: "",
      link2: "",
      btn3: "",
      link3: "",
    },
    "3": {
      img:
        "https://res.cloudinary.com/nancloud/image/upload/v1606220010/LSD/WORKS/03_bqnm6g.jpg",
      title: "STUDIO<br>ART.",
      subtitle: "Media, painting, Experiments",
      text:
        "The very root of our work, is to spend insane amounts of time working on just… you know… doodles. Those sketches and experiments lay the groundwork for our main projects, nurturing a strong dialogue between different aspects of arts and encouraging us to build bridges to connect them.",
      btn1: "Paintings PDF",
      link1: "https://res.cloudinary.com/nancloud/image/upload/v1606223340/LSD/WORKS/DOJOPAINTINGSPDF_k4ufkz.pdf",
      btn2: "Video 1",
      link2: "https://vimeo.com/266832387",
      btn3: "Video 2",
      link3: "https://vimeo.com/266847547",
    },
    "4": {
      img:
        "https://res.cloudinary.com/nancloud/image/upload/v1606220009/LSD/WORKS/04_g5zhrv.jpg",
      title: "SOUND<br>SCAPES.",
      subtitle: "Sound design",
      text:
        "Aside from heavily relying on our relationship with music, we are deeply interested in finding ways to connect media platforms to sound experiences, for example, we are particularly focused on sound design for web developments, live experiences and film arts, what gives our lab a broad dimension of the media spectrum.",
      btn1: "Sound Reel 1",
      link1: "https://www.youtube.com/watch?v=5lvoPGajpcM&feature=youtu.be",
      btn2: "",
      link2: "",
      btn3: "",
      link3: "",
    },
    "5": {
      img:
        "https://res.cloudinary.com/nancloud/image/upload/v1606220009/LSD/WORKS/05_oqrdvd.jpg",
      title: "CORPORATE<br>WORK.",
      subtitle: "Freakground Interactive",
      text:
        "Our corporate side, named FREAKGROUND INTERACTIVE, has been related to many different company projects ranging from branding to web and software development, and even museum installations. Our clients extend from the National Army of Colombia to Institutions like Centro de memoria, paz y reconciliación, Taller de diseño, museodata, and independent companies from various areas. For many years, FREAKGROUND INTERACTIVE has been fueling independent projects of the LIGHT SKILLS DOJO and has helped it grow in severe ways.",
      btn1: "Freakground Reel",
      link1: "https://vimeo.com/289049117",
      btn2: "",
      link2: "",
      btn3: "",
      link3: "",
    },
  };
  view = 1;
  viewValue = "1";

  changeView(value: number) {
    if (this.view == 0 && value == -1) {
      this.view = 5;
    } else if (this.view == 5 && value == 1) {
      this.view = 1;
    } else {
      this.view = this.view + value;
    }
    this.viewValue = this.view.toString();
  }

  mounted() {
    TweenMax.from(document.getElementById("project__curtain"), 1, {
      x: "-100vw",
      transformOrigin: "left 50%",
      ease: Power4.easeIn,
    });
    TweenMax.from(document.getElementById("project__container"), 1, {
      x: "-100vw",
      transformOrigin: "left 50%",
      ease: Power4.easeIn,
      delay: 0.4,
    });
  }

  leave(el: any, done: any) {
    TweenMax.to(document.getElementById("project__container"), 0.5, {
      y: "100vh",
      ease: Power4.easeIn,
      // onComplete: done,
    });
    TweenMax.to(document.getElementById("project__curtain"), 0.3, {
      y: "100vh",
      transformOrigin: "left 50%",
      ease: Power4.easeIn,
      delay: 0.3,
      onComplete: done,
    });
  }
}
